import React from 'react';
import { IAuditoriaLancamentoDiaNaoUtilResultado } from '../interfaces/IAuditoriaLancamentoDiaNaoUtil';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaLancamentoDiaNaoUtilResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Auditoria de Lançamentos em Finais de Semana e Feriados — não é um tributo, é uma auditoria de
// conformidade temporal que varre todo o livro (Ativo, Passivo, Resultado) procurando lançamentos
// registrados fora do expediente comercial (CPC 00). Sem aplicação de multa.
// COR-215: rótulo legível — evita mostrar "AVISO_TECNICO" cru (nome interno de status) na tela.
const getRotuloStatus = (status: string) => (status === 'AVISO_TECNICO' ? 'Fechamento de Competência' : status);

const AuditoriaResumoLancamentoDiaNaoUtil: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.lancamentosDiaNaoUtil?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Lançamentos em Finais de Semana e Feriados</h3>
      <p className='text-muted'>
        Auditoria complementar — lançamentos registrados em sábado, domingo, feriado nacional ou ponto facultativo
        exigem verificação de conformidade temporal (CPC 00). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Valor Identificado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_LANCAMENTO_DIA_NAO_UTIL')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Auditoria de Lançamentos em Finais de Semana e Feriados</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {getRotuloStatus(resultado.status)}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} lançamento{totalOcorrencias === 1 ? '' : 's'} em dia não útil identificado{totalOcorrencias === 1 ? '' : 's'} de {resultado.totalLancamentosAnalisados} analisado{resultado.totalLancamentosAnalisados === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFinanceiroTotal)}
                <div className='auditoria-kpi-help'>Sem multa aplicável (CPC 00)</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoLancamentoDiaNaoUtil;
